import { render, staticRenderFns } from "./app_testimonials.vue?vue&type=template&id=c2d47b70&"
import script from "./app_testimonials.vue?vue&type=script&lang=js&"
export * from "./app_testimonials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports